import React, { FC } from 'react';
import styles from './Partners.module.scss';
import logoDorcel from '../../../../assets/img/logoDorcel.svg';
import logoWicked from '../../../../assets/img/logoWicked.svg';
import logoPrivate from '../../../../assets/img/logoPrivate.svg';
import logoSinful from '../../../../assets/img/logoSinful.svg';
import logoLustCinema from '../../../../assets/img/logoLustCinema.svg';

interface PartnersI {}

const Partners: FC<PartnersI> = () => {
  return (
    <div className={styles.container}>
      <img src={logoDorcel} alt="" />
      <img src={logoWicked} alt="" />
      <img src={logoPrivate} alt="" />
      <img src={logoSinful} alt="" />
      <img src={logoLustCinema} alt="" />
    </div>
  );
};

export default Partners;
